module.exports = __webpack_public_path__ + "static/media/text-image.9712f7ba.avif";